<template>
    <div class="page">
        <div class="page__filter-bar">
            <filter-bar :max-filter-count="3" />
        </div>
        <promo-planner>
            <template v-slot:scenarios-component>
                <template v-if="shouldShowScenariosViewer">
                    <scenarios-viewer :key="selectedScenarioId" />
                </template>
            </template>
        </promo-planner>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { last, get } from 'lodash';
import featureFlags from '@enums/feature-flags';
import guardsMap from './planning-guard-map';

const { canViewScenariosFrontEnd } = featureFlags;

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name === from.name) {
            // navigating to the same route only params has changed
            // manually fire beforeEntered hook because it is not called automatically
            guardsMap[to.name](to, from, next);
            const toScenarioId = get(to, 'params.scenarioId', null);
            const fromScenarioId = get(from, 'params.scenarioId', null);
            if (toScenarioId && fromScenarioId && toScenarioId !== fromScenarioId) {
                this.emitter.emit('change-scenario-in-route');
            }
        } else {
            // When navigating from child route to parent, beforeEnter is not called automatically.
            // Check if toRoute exists in from.matched at an earlier index to detect child-to-parent navigation.
            const toRoute = last(to.matched);
            const toRouteIndex = from.matched.findIndex(record => record === toRoute);

            if (toRouteIndex >= 0 && toRouteIndex < from.matched.length - 1 && guardsMap[to.name]) {
                guardsMap[to.name](to, from, next);
                return;
            }

            next();
        }
    },

    computed: {
        ...mapState('clientConfig', ['toggleLogic']),
        ...mapGetters('subCampaigns', ['selectedSubCampaign']),
        ...mapGetters('scenarios', ['selectedScenarioId']),

        shouldShowScenariosViewer() {
            return this.toggleLogic[canViewScenariosFrontEnd] && this.selectedSubCampaign;
        },
    },
};
</script>

<style scoped lang="scss">
.page {
    height: 100%;

    &__filter-bar {
        padding: 1rem;
    }
}
</style>
